module.exports = new __parcel__URL__("Cards.c45ee53b.svg").toString();